// extracted by mini-css-extract-plugin
export var container = "banner-module--container--eabed";
export var imageTitle = "banner-module--imageTitle--d5236";
export var subtitle = "banner-module--subtitle--cfcd0";
export var subtitleContainer = "banner-module--subtitleContainer--2cd57";
export var titleContainer = "banner-module--titleContainer--518b4";